/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Font_LargeInputs */

const en_onboarding_font_large = /** @type {(inputs: Onboarding_Font_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large`)
};

const es_onboarding_font_large = /** @type {(inputs: Onboarding_Font_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grande`)
};

/**
* | output |
* | --- |
* | "Large" |
*
* @param {Onboarding_Font_LargeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_font_large = /** @type {((inputs?: Onboarding_Font_LargeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Font_LargeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_font_large(inputs)
	return en_onboarding_font_large(inputs)
});